import handleToggleListClick from './handle-toggle-list-click'

export default () => handleToggleListClick()
